import React from 'react';

export const AppPerfMarker = React.createContext();

export const withAppPerfMarker = WrappedComponent => (
  props => (
    <AppPerfMarker.Consumer>
      {(appPerfMarker =>
            (<WrappedComponent
              {...props}
              appPerfMarker={appPerfMarker}
            />))}
    </AppPerfMarker.Consumer>
  )
);
